export const APP_LIST = [
    // APP名称
    ['name', 'APP名称'],
    // APP ID
    ['packageName', 'APK包名'],
    // APP ID
    ['openAppId', '应用ID'],
    // 版本名
    ['versionName', '当前版本'],
    // 版本号
    ['versionCode', 'Version Code'],
    // 操作
    ['operate', '操作'],
]
